import React from 'react';
import Navigation from './LandingPage/Navigation';
import Hero from './LandingPage/Hero';
import Stats from './LandingPage/Stats';
import Features from './LandingPage/Features';
import HowItWorks from './LandingPage/HowItWorks';
import UseCases from './LandingPage/UseCases';
import Technology from './LandingPage/Technology';
import Testimonials from './LandingPage/Testimonials';
import CTA from './LandingPage/CTA';
import Footer from './LandingPage/Footer';
import './LandingPage.css';

function LandingPage() {
  return (
    <div className="landing-page">
      <Navigation />
      <Hero />
      <Stats />
      <Features />
      <HowItWorks />
      <UseCases />
      <Technology />
      <Testimonials />
      <CTA />
      <Footer />
    </div>
  );
}

export default LandingPage;

